import { useSelector } from 'react-redux';

import {
  selectFilterData,
  selectFilterCriteriaData
} from 'pages/LocationManagement/ActiveLocationsMap/selectors';

export function useActiveLocationsMapSelector() {
  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  return {
    filter,
    filterCriteria
  };
}
